import React from 'react';
import { BackButton } from '../../../../common/elements';
import { PrismicDocumentHelper } from '../../../../../helpers/prismicHelpers/PrismicHelpers';
import { eventListHelper } from '../../../../../helpers/prismicHelpers/prismic-custom-helpers/EventHelpers';
import EventInfo from '../elements/EventInfo';

class EventsFullView extends React.Component {

    constructor(){
        super()
        this.state = {
            event: ''
        }
    }

    componentWillMount(){
        this.getEvent()
    }

    async getEvent(){ 
        const params = this.props.params.eventId;
        const event = eventListHelper( await PrismicDocumentHelper('document.id', params, false, 'at'));

        this.setState({ event });
    }
    render () {
        return (
            <EventInfo event={this.state.event}/>
        )
    }
}

export default EventsFullView


// WEBPACK FOOTER //
// src/client/components/site/features/events/pages/EventsFullView.js